import { useRef } from "react";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";
import { DOCUMENT_TYPES, HTTP_STATUSES } from "@miplatform/constants";
import { externalReferenceId } from "@miplatform/utils";
import { useDocuments } from "@mibuildweb/hooks";
import { IItemData, IItemDocument } from "../../Items.types";

export const useItemCostPricingTabViewModel = ({
  setValue,
  watch,
}: IUseItemCostPricingTabViewModelProps) => {
  const quoteRef = useRef<HTMLInputElement>(null);
  const {
    id,
    quoteDocument: { id: quoteDocumentId, modifiedOn } = {} as IItemDocument,
  } = watch();

  const {
    isLoading: isDocumentLoading,
    createDocument,
    deleteDocument,
  } = useDocuments();

  const handleUploadQuote = async (file: File) => {
    const params = {
      title: file.name,
      documentType: DOCUMENT_TYPES.QUOTE,
      externalReferenceId: externalReferenceId.getMaterialRefId({
        materialId: id,
      }),
      applyWatermark: false,
    };
    if (quoteRef.current) {
      quoteRef.current.value = "";
    }
    const { data, status } = await createDocument({
      data: file,
      params,
      contentType: file.type,
    });
    if (status === HTTP_STATUSES.OK) {
      setValue("quoteDocument", data, { shouldValidate: true });
    }
  };

  const deleteQuote = async () => {
    const response = await deleteDocument({
      id: quoteDocumentId,
      modifiedOn,
    });
    if (response.status === HTTP_STATUSES.OK) {
      setValue("quoteDocument", {} as any, { shouldValidate: true });
    }
    return response;
  };

  const handleUpdateQuote = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (!files || files.length === 0) {
      return;
    }
    const response = await deleteQuote();
    if (response.status === HTTP_STATUSES.OK) {
      handleUploadQuote(files[0]);
    }
  };

  return {
    isLoading: isDocumentLoading,
    quoteRef,
    deleteQuote,
    handleUpdateQuote,
    handleUploadQuote,
  };
};

interface IUseItemCostPricingTabViewModelProps {
  watch: UseFormWatch<IItemData>;
  setValue: UseFormSetValue<IItemData>;
}
